import { gql } from "@apollo/client";

/**
 * The role the agent generated. Shared by the queued-task payload and the legacy
 * job-status payload, which both resolve to AiRoleBuilderResults.
 */
const aiGeneratedMissionRoleFields = `
  jobTitle
  jobDescription
  archetypes
  disciplines
  primarySkills
  secondarySkills
  otherSkills
  engagementType
  workArrangement
  videoInterviewQuestions {
    title
    description
  }
`;

const aiRoleBuilderResultsFields = `
  missionRole {
    ${aiGeneratedMissionRoleFields}
  }
`;

const aiRoleBuilderRequestFields = `
  companyName
  companyUrl
  jobDescription
  jobDescriptionFileName
  jobDescriptionFileUrl
`;

const aiRoleBuilderTaskFields = `
  id
  taskId
  status
  agentStatus
  stepsCompleted
  stepsTotal
  label
  missionId
  missionRoleId
  submittedById
  submittedByName
  submittedAt
  finishedAt
  errorMessage
  ${aiRoleBuilderRequestFields}
  results {
    ${aiRoleBuilderResultsFields}
  }
`;

// Legacy single-job shape, still used by the AI interview-questions flow.
const aiRoleBuilderJobFields = `
  jobId
  status
  results {
    ${aiRoleBuilderResultsFields}
  }
`;

const AI_ROLE_BUILDER_TASK_FIELDS = gql`
  fragment AIRoleBuilderTaskFields on AiRoleBuilderTask {
    ${aiRoleBuilderTaskFields}
  }
`;

const AI_ROLE_BUILDER_JOB_FIELDS = gql`
  fragment AIRoleBuilderJobFields on AiRoleBuilderJob {
    ${aiRoleBuilderJobFields}
  }
`;

export { AI_ROLE_BUILDER_TASK_FIELDS, AI_ROLE_BUILDER_JOB_FIELDS };
